a.s.itempicker = (function(){
	var my = {
		selectedItems: {}, // Track selected items across pagination {iid: itemObject}
		pick:function(cb,o){
			var multiple = o.multiple ?? false;
			var grouped_list = o.grouped_list ?? true;
			var select_kit_as_whole = o.select_kit_as_whole ?? true;
			var filter = o.filter || {};
			filter.offset = 0; // Initialize offset
			my.selectedItems = {}; // Reset selected items
			tpl.run({tpl:'/tpl/shared/itempicker/main.ejs',data:{
				multiple:multiple
			},cb:function(content){
				var token = a.popup.create({
					title:'Select item',
					width:700,
					height:500,
					content:content,
					show_actions:multiple,
					btntitle:'Select (0)',
					add_cancel: true,
					submit:function(){
						// Rebound in search result
					},
					close:function(){

					},
					ready:function(token){
						var win = $('#popupid_'+token);
						if (multiple) {
							// Disable submit button
							$('button[data-btn="btn_submit"]',win).prop('disabled',true);
						}
						if (filter.q) {
							$('input[name="q"]',win).val(filter.q);
						}
						// Focus search
						$('input[name="q"]',win).focus();
						$('input[name="q"]',win).unbind('keyup').keyup(function(){
							filter.offset = 0; // Reset offset on new search
							my.search(win,token,$('input[name="q"]',win).val(),filter,multiple,grouped_list,select_kit_as_whole,cb);
						});
						// Initial search
						my.search(win,token,$('input[name="q"]',win).val(),filter,multiple,grouped_list,select_kit_as_whole,cb);
					}
				});
			}});
		},
		search:debounce(function(win,token,q,filter,multiple,grouped_list,select_kit_as_whole,cb){
			filter.q = q;
			filter.token = localStorage.getItem('token');
			filter.accountname = localStorage.getItem('accountname');
			$('button[data-btn="btn_submit"]',win).prop('disabled',true).text('Select (0)');
			my.loader.add(win);
			if (multiple) {
				var tpl_name = 'list_multiple.ejs';
			}
			else {
				var tpl_name = 'list.ejs';
			}
			$.ajax({
				type:'GET',
				url:'/api/item/list/',
				data:filter,
				dataType:'json',
				cache: false,
				success:function(result) {
					result.grouped_list = grouped_list;
					result.select_kit_as_whole = select_kit_as_whole;
					if (typeof(result.list)!=='undefined') {
						tpl.run({tpl:'/tpl/shared/itempicker/'+tpl_name,data:result,cb:function(content){
							$('div[data-area="result"]',win).empty().append(content);
							if (multiple) {
								// Restore previously selected items
								result.list.forEach(function(item, index) {
									if (my.selectedItems[item.id]) {
										$('input[name="itemlist[]"][value="'+item.id+'"]',win).prop('checked', true);
									}
								});
								// Update submit button text
								var selectedCount = Object.keys(my.selectedItems).length;
								if (selectedCount > 0) {
									$('button[data-btn="btn_submit"]',win).prop('disabled',false).text('Select ('+selectedCount+')');
								}
								// Bind checkbox change
								$('input[name="itemlist[]"]',win).unbind('change').change(function(){
									var iid = $(this).val();
									var index = $(this).parent().parent().attr('data-index');
									if (select_kit_as_whole && $(this).attr('data-kit-id').length > 0) {
										if ($(this).is(":checked")) {
											$('input[data-kit-id="'+$(this).attr('data-kit-id')+'"]',win).prop('checked',true);
											// Add all kit items to selectedItems
											$('input[data-kit-id="'+$(this).attr('data-kit-id')+'"]',win).each(function(){
												var kitIid = $(this).val();
												var kitIndex = $(this).parent().parent().attr('data-index');
												if (result.list[kitIndex] && result.list[kitIndex].id == kitIid) {
													my.selectedItems[kitIid] = result.list[kitIndex];
												}
											});
										}
										else {
											$('input[data-kit-id="'+$(this).attr('data-kit-id')+'"]',win).prop('checked',false);
											// Remove all kit items from selectedItems
											$('input[data-kit-id="'+$(this).attr('data-kit-id')+'"]',win).each(function(){
												var kitIid = $(this).val();
												delete my.selectedItems[kitIid];
											});
										}
									}
									else {
										// Single item toggle
										if ($(this).is(":checked")) {
											if (result.list[index] && result.list[index].id == iid) {
												my.selectedItems[iid] = result.list[index];
											}
										}
										else {
											delete my.selectedItems[iid];
										}
									}
									// Update button
									var selectedCount = Object.keys(my.selectedItems).length;
									if (selectedCount > 0) {
										$('button[data-btn="btn_submit"]',win).prop('disabled',false).text('Select ('+selectedCount+')');
									}
									else {
										$('button[data-btn="btn_submit"]',win).prop('disabled',true).text('Select (0)');
									}
								});
								// Bind submit button
								$('button[data-btn="btn_submit"]',win).unbind('click').click(function(){
									var outputlist = Object.values(my.selectedItems);
									cb(outputlist);
									a.popup.remove(token,function(){});
								});
								// Bind item select buttons
								$('button[data-action="select_item"]',win).unbind('click').click(function(){
									var outputlist = [];
									var index = $(this).attr('data-index');
									if (result.list[index].id==$(this).attr('data-iid')) {
										outputlist.push(result.list[index]);
										cb(outputlist);
										a.popup.remove(token,function(){});
									}
								});
							}
							else {
								// Bind click callback
								$('div[data-area="result"] table tr',win).unbind('click').click(function(){
									if (result.list[$(this).attr('data-index')].id==$(this).attr('data-iid')) {
										// Return result
										cb(result.list[$(this).attr('data-index')]);
										// Close window
										a.popup.remove(token,function(){});
									}
									else {
										a.growl.create('Error','Unable to find correct item, please reload and try again',{});
									}
								});
							}
						}});
						// Render pagination
						if (result.pagination) {
							tpl.run({tpl:'/tpl/shared/itempicker/pagination.ejs?v='+v,data:result.pagination,cb:function(paginationcontent){
								$('[data-area="pagination"]',win).empty().append(paginationcontent).ready(function(){
									$('[data-area="pagination"] a[data-action="paginate"]',win).unbind('click').click(function(){
										filter.offset = $(this).attr('data-offset');
										my.search(win,token,q,filter,multiple,grouped_list,select_kit_as_whole,cb);
									});
								});
							}});
						}
						else {
							$('[data-area="pagination"]',win).empty();
						}
					}
					else {
						$('[data-area="pagination"]',win).empty();
						tpl.run({tpl:'/tpl/shared/itempicker/nohits.ejs',data:result,cb:function(content){
							$('div[data-area="result"]',win).empty().append(content).ready(function(){
								$('button[data-action="additem"]',win).unbind('click').click(function(e){
									e.preventDefault();
									require(['/js/itm.js'],
									function(){
										var ciobj = a.itm.it.new();
										ciobj.showPromptAfterCreate = false;
										ciobj.redirectAfterCreate = false;
										ciobj.close = function(){
											my.search(win,token,q,filter,multiple,grouped_list,select_kit_as_whole,cb);
										}
										ciobj.init();
									});
								});
							});
						}});
					}
				}
			});
		},250),
		loader:{
			add:function(win){
				$('div[data-area="result"]',win).empty().append('<i class="loader fa fa-spin fa-sync" style="font-size:36px;color:#ddd;margin:3em 0;"></i>');
			},
			remove:function(win){
				$('div[data-area="result"] .loader',win).remove();
			}
		}
	}
	return my;
}());